const DEFAULT_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

type BuildDateFormatterParams = Intl.DateTimeFormatOptions & {
  locales?: string | string[];
  noComma?: boolean;
};

export const buildDateFormatter = ({
  locales = undefined,
  noComma = true,
  ...options
}: BuildDateFormatterParams = {}) => {
  const formatter = new Intl.DateTimeFormat(locales, {
    ...DEFAULT_DATE_FORMAT_OPTIONS,
    ...options,
  });

  if (!noComma) return formatter;

  return {
    ...formatter,
    format: (date: Date) => formatter.format(date).replace(',', ''),
  };
};

export const dateFormatter = buildDateFormatter();

export const timezoneFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo',
  localeMatcher: 'best fit',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
  formatMatcher: 'best fit',
});

export const zonedTimeToCMSString = (date: Date) => {
  const _date = timezoneFormatter.format(date);
  const [datePart, timePart] = _date.includes(',')
    ? _date.split(',')
    : _date.split(' ');
  const [day, month, year] = datePart?.trim()?.split('/').map(Number) ?? [];
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(
    2,
    '0'
  )}T${timePart?.trim()}`;
};
